export default {
  discount_types: {
    cashback: 'Puntos de fidelidad',
    promo_code: 'Código promocional',
  },
  input: {
    label: '{{cashbackLabel}} o {{promoCodeLabel}}',
    placeholder: 'Código promocional',
  },
  buttons: {
    apply: 'Aplicar',
    remove: 'Eliminar',
  },
  feedback: {
    login:
      '<highlight>Inicia sesión</highlight> para usar este código y verificar que no lo hayas usado antes. Inicia sesión e inténtalo de nuevo.',
    usage_threshold: 'El importe mínimo de la cesta para esta promoción es (excl. gastos de envío)',
    promo_code_added: 'Código promocional aplicado correctamente',
  },
};
